export const ensureTrailingSlash = (path: string): string => {
  // Regular expression to check if the path ends with a file pattern (e.g., .something)
  const isFile = /\.[a-zA-Z0-9]+$/.test(path)

  // Append a trailing slash if it's not a file
  return isFile ? path : `${path}${path.endsWith('/') ? '' : '/'}`
}
